/** Тип зарплаты сотрудника. */
export enum EmployeeSalaryType {
    /** Процент. */
    Percent = "percent",

    /** Фиксированная сумма. */
    Fixed = "fixed",
}
